module.exports = "/src/views/player/help/images/bus.jpg";